var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 4.16667C11.6667 3.24619 12.4129 2.5 13.3334 2.5H16.6667C17.5872 2.5 18.3334 3.24619 18.3334 4.16667V15.8333C18.3334 16.7538 17.5872 17.5 16.6667 17.5H3.33341C2.41294 17.5 1.66675 16.7538 1.66675 15.8333V10.8333C1.66675 9.91286 2.41294 9.16667 3.33341 9.16667H6.66675V7.5C6.66675 6.57953 7.41294 5.83333 8.33341 5.83333H11.6667V4.16667ZM13.3334 15.8333H16.6667V4.16667H13.3334V15.8333ZM11.6667 7.5H8.33341V15.8333H11.6667V7.5ZM6.66675 10.8333H3.33341V15.8333H6.66675V10.8333Z",
    fill: "#CED4DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/ChartIcon.e700a87a6c2e280d3fcd37804b5a2903.svg";
export { ForwardRef as ReactComponent };